export default __webpack_public_path__ + "static/media/element_27.665947c3.avif";